import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Menu from './pages/Menu';
import About from './pages/About';
import Reservation from './pages/Reservation';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Privacy from './pages/Privacy';
import Imprint from './pages/Imprint';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="menu" element={<Menu />} />
        <Route path="about" element={<About />} />
        <Route path="reservation" element={<Reservation />} />
        <Route path="contact" element={<Contact />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="imprint" element={<Imprint />} />
      </Route>
    </Routes>
  );
}
